<script setup>
import { onMounted } from "vue";

onMounted(() => {
  const btn = document.querySelector("button.mobile-menu-button"),
    menu = document.querySelector(".mobile-menu");
  btn.addEventListener("click", () => {
    menu.classList.toggle("hidden");
  });
});
</script>
<template>
  <div class="fixed top-0 w-full z-50">
    <nav class="py-7 relative ease-in-out duration-500 mobile-nav stickyadd">
      <div class="container">
        <div class="flex items-center justify-between md:block">
          <div class="justify-between items-center flex w-full">
            <div class="z-50 relative">
              <router-link :to="{ name: 'home' }">
                <h1 class="text-3xl font-bold">
                  DentalSales
                </h1>
              </router-link>
            </div>
            <div>
              <button class="block md:hidden outline-none mobile-menu-button">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  stroke-width="2"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M4 6h16M4 12h16M4 18h16"
                  />
                </svg>
              </button>
            </div>
            <div class="hidden md:block">
              <ul class="list-none flex space-x-3 items-center">
                <li class="home">
                  <router-link
                    :to="{ name: 'home' }"
                    class="
                      font-medium
                      hover:text-green
                      ease-in-out
                      duration-300
                      inline-block
                      leading-6
                      p-2
                    "
                  >
                    О нас
                  </router-link>
                </li>
                <li class="features">
                  <router-link
                    :to="{ name: 'dentals' }"
                    class="
                      font-medium
                      hover:text-green
                      ease-in-out
                      duration-300
                      inline-block
                      leading-6
                      p-2
                    "
                  >
                    Стоматологии
                  </router-link>
                </li>
                <li class="client">
                  <router-link
                    :to="{ name: 'services' }"
                    class="
                      font-medium
                      hover:text-green
                      ease-in-out
                      duration-300
                      inline-block
                      leading-6
                      p-2
                    "
                  >
                    Услуги
                  </router-link>
                </li>
                <li class="contact">
                  <router-link
                    :to="{ name: 'contact' }"
                    class="
                      font-medium
                      hover:text-green
                      ease-in-out
                      duration-300
                      inline-block
                      leading-6
                      p-2
                    "
                  >
                    Контакты
                  </router-link>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="hidden mobile-menu">
          <div class="pt-7">
            <ul>
              <li class="home">
                <router-link
                  :to="{ name: 'home' }"
                  class="
                    font-medium
                    hover:text-green
                    ease-in-out
                    duration-300
                    inline-block
                    leading-6
                    p-2
                  "
                >
                  О нас
                </router-link>
              </li>
              <li class="features">
                <router-link
                  :to="{ name: 'dentals' }"
                  class="
                    font-medium
                    hover:text-green
                    ease-in-out
                    duration-300
                    inline-block
                    leading-6
                    p-2
                  "
                >
                  Стоматологии
                </router-link>
              </li>
              <li class="client">
                <router-link
                  :to="{ name: 'services' }"
                  class="
                    font-medium
                    hover:text-green
                    ease-in-out
                    duration-300
                    inline-block
                    leading-6
                    p-2
                  "
                >
                  Услуги
                </router-link>
              </li>
              <li class="contact">
                <router-link
                  :to="{ name: 'contact' }"
                  class="
                    font-medium
                    hover:text-green
                    ease-in-out
                    duration-300
                    inline-block
                    leading-6
                    p-2
                  "
                >
                  Контакты
                </router-link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </nav>
  </div>
</template>
